import { useCallback, useState } from "react";
import { useApolloClient } from "@apollo/client";
import { Building, DataQuery } from "@models/ISchema";
import { buildingQuery } from "../graphql/building.queries";

interface UseGetBuildingOptionsParams {
  scenario: string;
  campusId?: string;
}

const useGetBuildingOptions = ({ scenario, campusId = null }: UseGetBuildingOptionsParams) => {
  const client = useApolloClient();
  const [optionsBuilding, setOptionsBuilding] = useState<any[]>([]);

  const getBuildingOptions = useCallback(async () => {
    try {
      const response = await client.query({
        query: buildingQuery,
        variables: {
          scenarioId: scenario,
          filter: campusId ? { fields: { campusId: { eq: campusId } } } : undefined,
        },
      });
      const dataQuery: DataQuery = response?.data?.data;
      const optBuildings =
        dataQuery?.buildings?.items?.map((building: Building) => ({
          label: building.name,
          value: building.id,
        })) ?? [];
      setOptionsBuilding(optBuildings);
    } catch (error) {
      console.error(error);
    }
  }, [client, scenario, campusId]);

  return {
    optionsBuilding,
    getBuildingOptions,
  };
};

export default useGetBuildingOptions;
